<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createOrganization">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text ref="name" label="Organization Name" name="organizationname" v-model="organization.name" validation="required"></form-text>
                <form-textarea ref="description" label="Description" name="description" v-model="organization.description"></form-textarea>
              </div>
              <br/>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'
import database from '../../webmaster/Database/database'
import auth from '../../webmaster/Authentication/auth'
const user = auth.getUser()

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createorganization',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea
  },
  data () {
    return {
      user,
      organization: {
        name: '',
        description: '',
        users: {
          
        },
        workflows: {

        },
        meta_workflows: {

        }
      },
      meta_organization: {
        name: '',
        description: '',
      }
    }
  },
  methods: {
    createOrganization:function(e){
      var self = this
      e.preventDefault();
      //Set stanadmin user in users
      this.organization.users[this.user.uid] = {
        active: true,
        name: this.user.displayName,
        emailnotif:false,
        email: this.user.email,
        role: "99"
      };

      this.meta_organization.name = this.organization.name;
      this.meta_organization.description = this.organization.description;

      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        // Get a key for a new org.
        var newOrgKey = database.getDb().ref().child('orgs').push().key;
        var newWorkflowRangerKey = database.getDb().ref().child('orgs/' + newOrgKey + '/workflows').push().key;
        var updates = {};

        //Create org to add to user object
        var userorg = {
          active:true,
          name: this.organization.name,
          emailnotif:false,
          email: this.user.email,
          role: "99"
        }
        this.organization.workflows[newWorkflowRangerKey] = {
          name: "Ranger",
          active: true,
          description: "This workflow can be partially completed and contains all location tags in your facility",
          completions: {},
          lastcompleted: '',
          ranger : true,
        }
        this.organization.meta_workflows[newWorkflowRangerKey] = {
          name: "Ranger",
          active: true,
          description: "This workflow can be partially completed and contains all location tags in your facility",
          lastcompleted: '',
          ranger : true,
        }

        updates['/users/' + this.user.uid + '/orgs/' + newOrgKey] = userorg;
        updates['/orgs/' + newOrgKey] = this.organization;
        updates['/meta_orgs/' + newOrgKey] = this.meta_organization;

        database.getDb().ref().update(updates, function(){
          self.$router.push('/stanadmin/organizations')
        });
      }, () => {});

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateOrganization.vue?ece3ef02